<template>
  <div
    @keyup.enter="createCompany"
    class="mt-6 p-lg-6 p-3"
  >
    <h3 class="text-secondary font-weight-light text-center">{{ $t("common.welcome_screen.choose_a_name_for_your_workspace") }}</h3>
    <input
      v-model="name"
      type="text"
      class="form-control"
      :placeholder="$t('common.welcome_screen.enter_workspace_name')"
      autofocus
    >

    <p class="mt-4 text-secondary">{{ $t("common.welcome_screen.work_alone_or_with_teammates") }}</p>
    <div class="btn-group-toggle" data-toggle="buttons">
      <label
        @click="makeWorkspacePersonal()"
        :class="[showSizeSelect === false ? 'active' : '']"
        class="btn btn-sm btn-white mt-1"
      >
        <input type="radio" name="options" id="Personal" checked=""> {{ $t("common.welcome_screen.personal_workspace") }}<i class="fe fe-user-check ml-2"></i>
      </label>
      <label
        @click="makeWorkspaceForTeam()"
        :class="[showSizeSelect === true ? 'active' : '']"
        class="btn btn-sm btn-white mt-1"
      >
        <input type="radio" name="options" id="Team" checked=""> My Team and me<i class="fe fe-users ml-2"></i>
      </label>
    </div>

    <div v-if="showSizeSelect">
      <p class="mt-4 text-secondary">{{ $t("common.welcome_screen.how_many_people_work_for_the_company") }}</p>
      <div class="btn-group-toggle" data-toggle="buttons">
        <label
          @click="size = 'under 20'"
          :class="[size === 'under 20' ? 'active' : '']"
          class="btn btn-sm btn-white mt-1"
        >
          <input type="radio" name="options" id="uner20" checked=""> under 20 <i class="fe fe-user"></i>
        </label>
        <label
          @click="size = 'under 100'"
          :class="[size === 'under 100' ? 'active' : '']"
          class="btn btn-sm btn-white mt-1"
        >
          <input type="radio" name="options" id="under100" checked=""> under 100 <i class="fe fe-user"></i>
        </label>
        <label
          @click="size = 'under 500'"
          :class="[size === 'under 500' ? 'active' : '']"
          class="btn btn-sm btn-white mt-1"
        >
          <input type="radio" name="options" id="under500" checked=""> under 500 <i class="fe fe-users"></i>
        </label>
        <label
          @click="size = 'over 500'"
          :class="[size === 'over 500' ? 'active' : '']"
          class="btn btn-sm btn-white mt-1"
        >
          <input type="radio" name="options" id="over500" checked=""> over 500 <i class="fe fe-users"></i>
        </label>
      </div>
    </div>

    <button
      @click="createCompany"
      class="btn btn-sm btn-primary mt-4 float-right"
    >
      {{ $t("common.welcome_screen.create") }} {{size === 'personal' ? 'Workspace' : 'Company'}} <i class="fe fe-arrow-right"></i>
    </button>
    <button
      @click="emitStep('joinCompany')"
      class="btn text-muted btn-sm btn-link mt-4 float-right mr-2"
    >
      <i class="fe fe-arrow-left"></i> {{ $t("common.welcome_screen.wait_to_be_invited") }}
    </button>

  </div>
</template>

<script>
  import { AuthStepsMixin } from '../mixins/AuthStepsMixin';
  import { createCompany } from '../../../api/authApi';

  export default {
    name: 'CreateCompanyStep',
    mixins: [AuthStepsMixin],
    data () {
      return {
        name: 'Workspace',
        size: 'under 100',
        showSizeSelect: true,
      };
    },
    methods: {
      makeWorkspacePersonal () {
        this.size = 'personal';
        this.showSizeSelect = false;
      },
      makeWorkspaceForTeam () {
        this.size = 'under 100';
        this.showSizeSelect = true;
      },
      createCompany: async function () {
        if (this.name.length >= 3) {
          const ok = await createCompany(this.name, this.size);
          if (ok) {
            this.$emit('setCompanyName', this.name);
            this.emitStep(this.size === 'personal' ? 'finish' : 'companyInvite');
          } else {
            this.$noty.error('An Error occurred');
          }
        } else {
          this.$noty.show('Actually, you company name should be 3 characters or longer');
        }
      },
    },
  };
</script>

<style scoped>

</style>
